import { render } from "./BoostPost.vue?vue&type=template&id=2f2fc176&scoped=true"
import script from "./BoostPost.vue?vue&type=script&lang=js"
export * from "./BoostPost.vue?vue&type=script&lang=js"

import "./BoostPost.vue?vue&type=style&index=0&id=2f2fc176&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2fc176"]])

export default __exports__